import styled, { css } from 'styled-components';

const mapMarket = '/static/images/footer/map-marker.svg';
const close = '/static/images/footer/close.svg';

export const AddressOverlay = styled.div`
    display: block;
    overflow: hidden;
    position: absolute;
    left: 0;
    top: 0;
    visibility: hidden;
    height: 100%;
    width: 100%;
    z-index: 0;
`;

export const AddressesContainer = styled.div`
    background-color: #ebebeb;
    font-family: 'robotoLight', Arial, Helvetica, sans-serif;
    flex-wrap: nowrap;
    flex-direction: column;
    visibility: hidden;
    height: 100%;
    width: 100%;
    transition: transform 0.5s ease, opacity 0.5s ease;

    ${props => props.isOpen ? css`
        opacity: 1;
        transform: translateX(0%);
        visibility: visible;
    ` : css`
        opacity: 0;
        transform: translateX(-100%);
        visibility: visible;
    `}

    @media (max-width: 906px) {
        padding-top: 60px;
        padding-bottom: 80px;
    }
`;

export const AddressesTitle = styled.p`
    margin: 0;
    margin-bottom: 15px;
    font-size: 20px;
    line-height: 28px;
    color: #000;
`;
export const AddressesClose = styled.div`
    content: '';
    color: #000;
    cursor: pointer;
    position: absolute;
    top: 5px;
    right: 30px;
    width: 30px;
    height: 30px;
    background: url(${close}) center / contain no-repeat;
    z-index: 10;
    @media (max-width: 906px) {
        top: 40px;
    }
`;

export const AddressesList = styled.div`
    align-items: flex-start;
    flex-direction: column;
    flex-wrap: nowrap;
    padding-bottom: 10px;
    padding-right: 40px;
    position: relative;
    height: calc(100% - 45px);
    overflow: auto;
`;

export const AddressItem = styled.div`
    position: relative;
    margin: 0;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 24px;
    color: #1a1a1a;
    padding-left: 27px;
    &::before {
        content: '';
        color: #000;
        position: absolute;
        top: 2px;
        left: 0;
        width: 14px;
        height: 20px;
        background: url(${mapMarket}) center / contain no-repeat;
        z-index: 10;
    }
`;

export const AddressesLink = styled.a`
    border-bottom: 1px dotted currentColor;
    color: #007ae5;
    font-size: 16px;
    line-height: 24px;
    text-decoration: none;
    transition: 0.25s;

    &:hover {
        color: #ed1c24;
    }
`;
export const AddressesLinkContainer = styled.div`
    margin-top: 10px;
`;

export const ScrollThumb = styled.div`
    background: #CECECE;
    border-radius: 15px;
    margin: 0 4px;
    width: 6px;
`;
